'use client';

import { closeCart, useCartStore } from '@/features/cart/store/cart';
import { useMediaQuery } from '@/hooks';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@andritzot/metris-web-ui/feedback/dialog';
import Panels from '@andritzot/metris-web-ui/layout/panels';
import { ArrowBackOutlined } from '@mui/icons-material';
import { useState } from 'react';

import CartSummaryPanel from '../CartSummaryPanel';
import PriceQuoteForm from '../PriceQuoteForm';

const CartDialog = () => {
  const [canSubmit, setCanSubmit] = useState(false);
  const isCartOpen = useCartStore((s) => s.isCartOpen);
  const isFormLoading = useCartStore((s) => s.isLoading);
  const { isMobile } = useMediaQuery();

  return (
    <Dialog open={isCartOpen} onClose={closeCart} maxWidth="lg" fullWidth fullScreen={isMobile}>
      <DialogTitle title="Selected solutions" onClose={closeCart} />
      <DialogContent sx={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <Panels.Group orientation={{ xs: 'vertical', md: 'horizontal' }} style={{ flex: 1, minHeight: 0 }}>
          <Panels.Item minSize="50%" surface>
            <CartSummaryPanel />
          </Panels.Item>
          <Panels.Separator variant="spacer" />
          <Panels.Item minSize="50%" surface>
            <PriceQuoteForm onCanSubmitChange={setCanSubmit} />
          </Panels.Item>
        </Panels.Group>
      </DialogContent>
      <DialogActions
        primaryAction={{
          label: 'Request Demonstration',
          type: 'submit',
          form: 'price-quote-form',
          disabled: !canSubmit,
          loading: isFormLoading,
        }}
        secondaryAction={{
          label: 'Search more',
          startIcon: <ArrowBackOutlined />,
          onClick: closeCart,
        }}
      />
    </Dialog>
  );
};

export default CartDialog;
